<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      flat
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text class="d-flex align-center justify-center">
          <div v-html="$t('common.message.timeout_msg1')" style="color:#000;text-align:center;font-size:16px!important;word-break:break-word;"></div>
        </v-card-text>
        <v-card-text class="d-flex align-center justify-center">
          <div v-html="$t('common.message.timeout_msg2')" style="color:#000;text-align:center;font-size:16px!important;word-break:break-word;"></div>
        </v-card-text>
        <v-card-text class="d-flex align-center justify-center">
          <div v-html="$t('common.message.timeout_msg3', {receipt_no: receipt_no})" style="color:#000;text-align:center;font-size:16px!important;word-break:break-word;"></div>
        </v-card-text>
        <v-card-text class="d-flex align-center justify-center">
          <div v-html="$t('common.message.timeout_msg4')" style="color:#000;text-align:center;font-size:16px!important;word-break:break-word;"></div>
        </v-card-text>
        <v-card-actions class="d-flex align-center justify-center pb-15">
          <v-btn class="sb_btn" @click="fnGoMyRequest()" dark color="#2a58ad">{{ $t('common.message.timeout_button') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  name: 'DialogTimeOut',
  props: {
  },
  components: {
  },
  data () {
    return {
      dialog: false,
      receipt_no: '',
      search_type_code: ''
    }
  },
  mounted () {
    eventBus.$off('CLOSE_DIALOG_TIMEOUT')
    eventBus.$on('CLOSE_DIALOG_TIMEOUT', () => {
      this.dialog = false
    })

    eventBus.$off('SHOW_DIALOG_TIMEOUT')
    eventBus.$on('SHOW_DIALOG_TIMEOUT', (options) => {
      this.receipt_no = options.receipt_no
      this.search_type_code = options.search_type_code

      this.dialog = true
    })
  },
  methods: {
    fnGoMyRequest() {
      this.$router.push('/myrequest?search_service_type_code='+ this.search_type_code +'&search_receipt_status_type_code=4301')
      this.dialog = false
    }
  }
}

</script>